import { render, staticRenderFns } from "./DocumentsSummary.vue?vue&type=template&id=68cf399f"
import script from "./DocumentsSummary.vue?vue&type=script&lang=js"
export * from "./DocumentsSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports